import { ReportState } from './report.model';

const reportDefault: ReportState = {
  data: null,
  pending: false,
};

export default reportDefault;
